import { apiFetch } from '../auth/apiFetch.ts';
import { useQuery } from '@tanstack/react-query';

export interface TelemetryReading {
  id: number;
  robot_id: string;
  ts: string;
  battery_pct: number | null;
  speed_mps: number | null;
  heading_deg: number | null;
  lat: number | null;
  lon: number | null;
  cpu_pct: number | null;
  disk_free_gib: number | null;
  disk_used_pct: number | null;
  temp_c: number | null;
  state: string | null;
  payload: Record<string, unknown>;
}

async function fetchTelemetry(robotId: string, limit: number): Promise<TelemetryReading[]> {
  const r = await apiFetch(
    `/api/robots/${encodeURIComponent(robotId)}/telemetry?limit=${limit}`,
  );
  if (!r.ok) throw new Error(`status ${r.status}`);
  const body = (await r.json()) as { readings?: TelemetryReading[] };
  return body.readings ?? [];
}

export function useTelemetry(robotId: string | undefined, opts?: { limit?: number }) {
  const limit = opts?.limit ?? 200;
  return useQuery({
    queryKey: ['telemetry', robotId, limit] as const,
    queryFn: () => fetchTelemetry(robotId as string, limit),
    enabled: !!robotId,
    refetchInterval: 5_000,
  });
}
